import React, { memo } from 'react';
import { Button } from 'components';
import { Box, Flex } from '@chakra-ui/layout';
import { useDisclosure } from '@chakra-ui/hooks';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import { openNotification } from 'utils/notification';
import { deleteClient } from 'services/deleteClient';
import { getItemStorage } from 'services/storage';

const RemoveClientModal: React.FC<{
  onRemoveClient: () => void;
}> = ({ onRemoveClient }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const handleChangeStatus = async (clientID: number) => {
    try {
      const response = await deleteClient(clientID);

      if (response.status === 204) {
        openNotification('Cliente removido com sucesso.', 'success');
        setTimeout(() => location.reload(), 1500);
        onRemoveClient();
      }
    } catch (error) {
      console.error(error);
    } finally {
      onClose();
    }
  };
  return (
    <Flex onClick={onOpen}>
      <Box w="100%">Remover cliente do Sistema</Box>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#22272D">Remover cliente ?</ModalHeader>
          <ModalCloseButton />
          <ModalBody color="#000">
            Tem certeza que deseja remover este cliente permanentemente do sistema?
          </ModalBody>

          <ModalFooter>
            <Box marginRight="1rem">
              <Button variant="gray" outline onClick={onClose}>
                Não
              </Button>
            </Box>
            <Box>
              <Button
                variant="danger"
                onClick={() => handleChangeStatus(getItemStorage('selectedClient') as number)}
              >
                Sim, quero remover
              </Button>
            </Box>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export const RemoveClient = memo(RemoveClientModal);
